module.exports = __webpack_public_path__ + "static/media/targeted.65012724.svg";